import { useQueries, useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { userService } from '../../../services/UserService';
import { tenantQueryKeys } from '../tenantQueryKeys';

export function useTenantLabelUsersQuery(labelId: string | undefined) {
  const { user } = useAuth();
  const isEnabled = Boolean(user) && Boolean(labelId);

  return useQuery({
    queryKey: tenantQueryKeys.labelUsers(labelId ?? ''),
    enabled: isEnabled,
    queryFn: () => {
      if (!labelId) {
        throw new Error('labelId is required');
      }
      return userService.listLabelUsers(labelId);
    },
  });
}

export function useTenantLabelUsersQueries(
  labelIds: ReadonlyArray<string>,
  enabled = true,
) {
  const { user } = useAuth();
  const isEnabled = enabled && Boolean(user);

  return useQueries({
    queries: labelIds.map((labelId) => ({
      queryKey: tenantQueryKeys.labelUsers(labelId),
      enabled: isEnabled && labelId.length > 0,
      queryFn: () => userService.listLabelUsers(labelId),
    })),
  });
}
